import { render, staticRenderFns } from "./DarkPopupNavigationBar.vue?vue&type=template&id=6b070cae&scoped=true&lang=pug"
var script = {}
import style0 from "./DarkPopupNavigationBar.vue?vue&type=style&index=0&id=6b070cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b070cae",
  null
  
)

export default component.exports